define('ZipCodeSelector.View', [
  'underscore',
  'SCView',
  'zip_code_selector.tpl'
], function ZipCodeSelectorViewModule(_, SCViewComponent, zipCodeSelectorTpl) {
  'use strict';

  var SCView = SCViewComponent.SCView;

  function ZipCodeSelectorView(options) {
    SCView.call(this, options);
    this.template = zipCodeSelectorTpl;
    this.model = options.model;
    this.environment = options.environment;
    this.events = {
      'keypress input[name="zipcode"]': 'onKeyPressInput',
      'change input[name="zipcode"]': 'onChangeInput',
      'click button[name="zipcode-update"]': 'onClickButton'
    };
  }

  ZipCodeSelectorView.prototype = Object.create(SCView.prototype);

  _.extend(ZipCodeSelectorView.prototype, {
    constructor: ZipCodeSelectorView,

    onKeyPressInput: function onKeyPressInput(event) {
      var keyCode = event.which || event.keyCode;
      if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
        // non-numeric
        event.preventDefault();
        return;
      }
      if (event.keyCode === 13) {
        // pressed enter
        event.preventDefault();
        this.updateZipCode();
      }
    },

    onClickButton: function onClickButton(event) {
      event.preventDefault();
      event.stopPropagation();
      this.updateZipCode();
    },

    updateZipCode: function updateZipCode() {
      this.model.setZipCode(this.getCurrentZipCode(), { save: true });
      this.model.update();
    },

    getCurrentZipCode: function getCurrentZipCode() {
      var $input = this.$('input[name="zipcode"]');
      return Number($input.val()) || null;
    },

    isLoaded: function isLoaded() {
      var model = this.model;
      var isLoading = model.isLoading();
      var shouldShow = model.shouldShow();
      return !isLoading && shouldShow;
    },

    getContext: function getContext() {
      var self = this;
      var model = this.model;
      var isLoaded = this.isLoaded();
      var shouldShow = model.shouldShow();
      var availLocations = model.getQuantityAvailableForLocations();
      var customTable = self.environment && self.environment.getConfig('locationShippingTimes.customTable');
      var locSize = 0;
      availLocations.forEach(function (loc) {
        var locations = model.getLocations();
        var locationId = loc.internalid;

        var location = locations.findWhere({ id: locationId });
        if (location) {
          locSize++;
        }
      });

      if(locSize === 0) {
        shouldShow = false;
      }

      var context = {
        isLoading: model.isLoading(),
        shouldShow: shouldShow,
        customTable: customTable
      };
      return _.extend(context, isLoaded ? this.getContextLoaded() : {});
    },

    getContextLoaded: function getContextLoaded() {
      return {
        zipCode: this.model.getZipCode()
      };
    }
  });

  return ZipCodeSelectorView;
});
